import { REQUEST_FEEDBACK_CHARACTERS_LIMIT } from './RequestFeedbackBody';

export const useSaveButtonDisabled = ({
  receiverEmployeeId,
  providerEmployees,
  isSaving,
  questionText,
}: {
  receiverEmployeeId: string | null;
  providerEmployees: number;
  isSaving: boolean;
  questionText: string;
}): {
  isDisabled: boolean;
  reason: string;
} => {
  if (isSaving) {
    return {
      isDisabled: true,
      reason: 'Requesting feedback...',
    };
  }

  if (!receiverEmployeeId) {
    return {
      isDisabled: true,
      reason: 'Please select a receiver',
    };
  }

  if (!providerEmployees) {
    return {
      isDisabled: true,
      reason: 'Please select at least one provider',
    };
  }

  if (questionText?.length > REQUEST_FEEDBACK_CHARACTERS_LIMIT) {
    return {
      isDisabled: true,
      reason: 'Feedback details character limit exceeded',
    };
  }

  return {
    isDisabled: false,
    reason: '',
  };
};
